import React, { Component } from 'react';
import {
    Link,
    withRouter,
} from 'react-router-dom';

import { auth, db } from '../../firebase';
import * as routes from '../../routes/routes';
import { Paper, Button, TextField, Typography } from '@material-ui/core';
import { toast } from 'react-toastify';
import firebase from 'firebase/app';

const RegisterPage = ({ history }) =>
    <div>
        <RegisterForm history={history} />
    </div>

const updateByPropertyName = (propertyName, value) => () => ({
    [propertyName]: value,
});

const INITIAL_STATE = {
    username: '',
    email: '',
    password: '',
    repeatPassword: '',
    error: null,
};

class RegisterForm extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown)
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown)
    }

    handleKeyDown = (event) => {
        //naci bolje resenje, sugavi enter okine create ako nisu uslovi ispunjeni
        const {
            username,
            email,
            password,
            repeatPassword,
            //error,
        } = this.state;

        const isInvalid =
            password !== repeatPassword ||
            password === '' ||
            username === '' ||
            email === '';
        if (event.key === "Enter" && !isInvalid) {
            this.onSubmit(event)
        }
    }

    onSubmit = (event) => {
        const {
            username,
            email,
            password,
        } = this.state;

        auth.createUserWithEmailAndPassword(email, password)
            .then(authUser => {
                authUser.user.sendEmailVerification().then(function () {
                    toast.success("A verification link has been sent to your email address! Please click the link to verify your account", {
                        position: "top-center",
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                    });
                }).catch(error => {
                    this.setState(updateByPropertyName('error', error));
                })
                db.createUser(username, email)
                this.setState(() => ({ ...INITIAL_STATE }));
            })
            .catch(error => {
                this.setState(updateByPropertyName('error', error));
            });

        event.preventDefault();
    }

    resendEmail = () => {
        firebase.auth().currentUser.sendEmailVerification().then(function () {
            toast.success("A verification link has been sent to your email address! Please click the link to verify your account", {
                position: "top-center",
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
            });
        }).catch(error => {
            this.setState(updateByPropertyName('error', error));
        })
    }

    render() {
        const {
            username,
            email,
            password,
            repeatPassword,
            error,
        } = this.state;

        const isInvalid =
            password !== repeatPassword ||
            password === '' ||
            username === '' ||
            email === '';

        return (
            <div className="padding-middle" >
                <div style={{
                    textAlign: 'center',
                }}>
                    <Paper className="papper-middle" >
                        <TextField
                            label={'Full name'}
                            required
                            value={username}
                            onChange={(event) => this.setState(updateByPropertyName('username', event.target.value))}
                        />
                        <br />
                        <TextField
                            label={'Email'}
                            required
                            value={email}
                            onChange={(event) => this.setState(updateByPropertyName('email', event.target.value))}
                        />
                        <br />
                        <TextField
                            type="password"
                            label={'Password'}
                            required
                            value={password}
                            onChange={(event) => this.setState(updateByPropertyName('password', event.target.value))}
                        />
                        <br />
                        <TextField
                            type="password"
                            label={'Password'}
                            required
                            value={repeatPassword}
                            onChange={(event) => this.setState(updateByPropertyName('repeatPassword', event.target.value))}
                        />
                        <Button
                            disabled={isInvalid}
                            className="formButton"
                            onClick={this.onSubmit}
                        >
                            {'Register'}
                        </Button>
                        {error && <Typography className="message-error">{error.message}</Typography>}
                        {error && <Button className="formButton" onClick={this.resendEmail}>Resend email</Button>}
                        <div style={{ flexDirection: 'row', flex: 1 }}>
                            <Link style={{ marginRight: '50px' }} to={routes.LOGIN}>Log in</Link>
                            <Link style={{ marginLeft: '50px' }} to={routes.FORGOT_PASSWORD}>Forgot password?</Link>
                        </div>
                    </Paper>
                </div>
            </div>
        );
    }
}

const RegisterLink = () =>
    <Typography className="p-css">
        Don't have an account?
    {' '}
        <Link to={routes.REGISTER}>Sign Up</Link>
    </Typography>

export default withRouter(RegisterPage);

export {
    RegisterForm,
    RegisterLink,
};


// WEBPACK FOOTER //
// ./src/components/Register/index.js